<template>
    <layout v-bind:user="user" v-bind:shops="shops" v-bind:brands="brands" v-bind:company="company" title="お知らせ一覧">
        <main class="ly_main"><div class="wrap"><div class="inner">
            <!--Heading-->
            <h1 class="heading_page-title flex _y-center">
                <div class="main"><span>News</span></div>
                <div class="controller flex _right _y-center">
                </div><!--/.controller-->
            </h1><!--/.heading_page-title-->
            <!--ShopList-->
            <div class="md_common-bl" id="bland-list">
                <div class="inner">
                    <div class="table_common _use-checkbox">
                        <table>
                            <thead>
                                <tr>
                                    <th class="_pointer" @click="clickSort('created_at')">作成日時 {{getTriangle('created_at')}}</th>
                                    <th class="_pointer" @click="clickSort('title')">タイトル {{getTriangle('title')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="n in newsList" :key="n.id" >
                                    <td>{{formatDate(n.created_at)}}</td>
                                    <td v-if="n.type == 0"><Link class="ovl" :href="route(routeNewsName, n.id)"></Link>【運営からのお知らせ】{{n.title}}</td>
                                    <td v-if="n.type == 1 && !n.showroom_id"><Link class="ovl" :href="route(routeTalkName)" :data="{shop_id: n.shop_id, brand_id: n.brand_id}"></Link>{{n.message}}</td>
                                    <td v-if="n.type == 1 && n.showroom_id"><Link class="ovl" :href="route(routeTalkName)" :data="{showroom_id: n.showroom_id, brand_id: n.brand_id}"></Link>{{n.message}}</td>
                                    <td v-if="n.type == 2">{{n.message}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <pagination v-if="showPagination" :list="links" />
                    </div><!--/.table_common-->
                </div><!--/.md_common-bl-->
            </div>
        </div></div><div class="heading_page-title-en"><span>{{backName}}</span></div></main>
    </layout>
</template>
<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import Pagination from '@/components/Admin/Pagination'
    import dayjs from 'dayjs'
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3'

    import ScrollHint from 'scroll-hint'

    export default {
        components: {
            "layout": AdminLayout,
            "pagination": Pagination,
            "Link": Link,
            "ScrollHint": ScrollHint,
        },
        data() {
            return {
                showPagination: false,
                links: '',
                list_sorter: {column: "", order: ""}
            }
        },
        props: {
            news: Object,
            user: Object,
            company: Object,
            shops: Object,
            brands: Object,
            listSorter: Object,
        },
        mounted() {
            if(this.listSorter){
                this.list_sorter = this.listSorter;
            };
            new ScrollHint('.table_common');
        },
        methods: {
            formatDate: dateStr => dayjs(dateStr).format('YYYY/MM/DD'),
            clickSort(sorter){
                if(this.list_sorter.column !== sorter){ // 1回目クリックされたらascでソート
                    this.list_sorter.column = sorter;
                    this.list_sorter.order = "ASC";
                } else {
                    if(this.list_sorter.order == "ASC"){
                        this.list_sorter.order = "DESC"; // 2回目クリックされたらdescでソート
                    } else {
                        this.list_sorter.column = ""; // 3回目クリックされたらソートを外す
                        this.list_sorter.order = "";
                    }
                }
                const { column, order } = this.list_sorter;
                const form = reactive({
                    listSorter: { column, order }
                })
                Inertia.get(location.pathname, form);
            },
            addSorterToLinks(sorter, links){
                for(var i in links) {
                    var link = links[i];
                    if (link.url) {
                        link.url = link.url + `&listSorter[column]=${sorter.column}&listSorter[order]=${sorter.order}`;
                    }
                }
            },
            getTriangle(name){
                if(name == this.list_sorter.column){
                    return this.list_sorter.order == "ASC" ? "▼" : "▲";
                } else return "▼";
            }

        },
        computed: {
            newsList() {
                if (this.news.data) {
                    this.showPagination = true;
                    this.links = this.news;
                    if (this.listSorter) {
                        this.addSorterToLinks(this.listSorter, this.news.links);
                    }
                    return this.news.data;
                } else {
                    return null;
                }
            },
            routeNewsName() {
                if (location.pathname.match(/shop/)) {
                    return 'admin.shop.news.detail';
                } else if (location.pathname.match(/brand/)) {
                    return 'admin.brand.news.detail';
                } else if (location.pathname.match(/showroom/)) {
                    return 'admin.showroom.news.detail';
                }
            },
            routeTalkName() {
                if (location.pathname.match(/shop/)) {
                    return 'admin.shop.talk';
                } else if (location.pathname.match(/brand/)) {
                    return 'admin.brand.talk';
                } else if (location.pathname.match(/showroom/)) {
                    return 'admin.showroom.talk';
                }
            },
            backName() {
                if (this.user.type == 0) {
                    return 'Admin';
                } else if (this.user.type == 1) {
                    return 'Shop';
                } else if (this.user.type == 2) {
                    return 'Brand';
                } else if (this.user.type == 3) {
                    return 'ShowRoom';
                }
            },
        }
    }
</script>
